<script>
  import { _ } from "svelte-i18n";
  let showDetails = true;
  function toggle() {
    showDetails = !showDetails;
  }
  export let comment = "";
</script>

<div class="form-section form-section--paddingless">
  <h3>
    <button
      on:click={toggle}
      type="button"
      class="button-text button-text--chevron-down {showDetails
        ? 'is-toggled'
        : ''}">{$_("dayParameters.form.comment")}</button
    >
  </h3>
  <div class={showDetails ? "" : "radio-group--default-hide"}>
    <div class="form-section form-section--paddingless">
      <div class="">
        <fieldset>
          <label class="input" for="comment-activity"
            ><textarea
              rows="5"
              type="text"
              inputmode="text"
              name="comment-activity"
              id="comment-activity"
              class="input__text"
              bind:value={comment}
            ></textarea></label
          >
        </fieldset>
      </div>
    </div>
  </div>
</div>
